jQuery(document).ready(function($) {
	var form     = wc_bookings_booking_form.wc_booking_form,
		$picker  = form.find( '.picker' ),
		startSel = null,
		endSel   = null;

	if ( $picker.data( 'is_range_picker_enabled' ) ) {
		form.find( 'p.wc_bookings_field_duration' ).hide();
	}

	$('.block-picker').on('click', 'a', function(){
		var value  = $( this ).data( 'value' );
		var target = $( this ).closest( 'div' ).find( 'input' );
		var range;

		if ( ! $picker.data( 'is_range_picker_enabled' ) ) {
			// If we are not using range picker just trigger change for AJAX request.
			target.val( value ).change();
			return;
		}

		// Unselect everything and set duration to default value.
		$( this ).parent().siblings().children( 'a' ).removeClass( 'selected' );
		$( '#wc_bookings_field_duration' ).val( 1 );

		if ( startSel && endSel ) {
			// If we have both start and end selection, reset end.
			startSel = $( this ).parent();
			endSel   = null;
		} else if ( startSel ) {
			value = startSel.find( 'a' ).data( 'value' );
			// If we have start selection, we set end selection and do calculation.
			endSel = $( this ).parent();

			if ( startSel.is( endSel ) ) {
				// Not a range, just a single entry.
				range = startSel;
			} else {
				// There is a range so select every entry inclusive.
				range = startSel.nextUntil( endSel ).addBack();
				range = range.add( range.last().next() );
			}

			range.children( 'a' ).addClass( 'selected' );

			// Set duration and date and trigger change for AJAX request.
			$( '#wc_bookings_field_duration' ).val( range.length );
			target.val( value ).change();
		} else {
			startSel = $( this ).parent();
		}
	});

	var max_width  = 0;
	var max_height = 0;

	$('.block-picker a').each(function() {
		var width  = $(this).width();
		var height = $(this).height();
		if ( width > max_width ) {
			max_width = width;
		}
		if ( height > max_height ) {
			max_height = height;
		}
	});

	$('.block-picker a').width( max_width );
	$('.block-picker a').height( max_height );
});
